export type PlanDimDraftSelections = Record<string, string[]>;

export const selectionsFromRedux = (selectedBlockDimension: any[]): PlanDimDraftSelections => {
  const draft: PlanDimDraftSelections = {};
  (selectedBlockDimension ?? []).forEach((entry) => {
    const dimensionName = Object.keys(entry ?? {})[0];
    if (!dimensionName) return;
    draft[dimensionName] = Array.isArray(entry[dimensionName]) ? [...entry[dimensionName]] : [];
  });
  return draft;
};

export const selectionsToRedux = (draft: PlanDimDraftSelections) =>
  Object.entries(draft).map(([name, items]) => ({ [name]: items }));

/** Every item left unchecked is the real empty default — nothing filters
 * anything either way, but a blank modal doesn't look like filters are
 * already applied. */
export const buildDefaultDraft = (
  dimensions: Array<{ name: string; items: string[] }>,
): PlanDimDraftSelections => {
  const draft: PlanDimDraftSelections = {};
  dimensions.forEach((dimension) => {
    draft[dimension.name] = [];
  });
  return draft;
};

/** Like `selectionsFromRedux`, but a dimension holding every one of its
 * items (the "no filter" default) displays as unchecked rather than fully
 * checked — a full selection applies no filter, so showing it as checked
 * reads as "filters are on" when none are. A genuinely narrowed selection
 * still shows its real checked items. */
export const selectionsFromReduxForDisplay = (
  selectedBlockDimension: any[],
  dimensions: Array<{ name: string; items: string[] }>,
): PlanDimDraftSelections => {
  const totalsByName = new Map(
    dimensions.map((dimension) => [dimension.name, dimension.items.length]),
  );
  const draft: PlanDimDraftSelections = {};
  (selectedBlockDimension ?? []).forEach((entry) => {
    const dimensionName = Object.keys(entry ?? {})[0];
    if (!dimensionName) return;
    const values = Array.isArray(entry[dimensionName]) ? entry[dimensionName] : [];
    const totalItems = totalsByName.get(dimensionName) ?? 0;
    draft[dimensionName] = values.length >= totalItems ? [] : [...values];
  });
  return draft;
};

export const countActiveFilterItems = (source: any[]) =>
  (source ?? []).reduce((count: number, item: any) => {
    const values = Object.values(item ?? {})[0];
    return count + (Array.isArray(values) ? values.length : 0);
  }, 0);
